import { navData } from "./navData";
import { getUserRole } from "../common/helpers";

export const normalizePath = (path = "/") => {
  const normalizedPath = `/${path}`
    .replace(/\/+/g, "/")
    .replace(/\/$/, "");

  return normalizedPath || "/";
};

export const getAccessibleNavItems = (roleId) => {
  const role = getUserRole(roleId);

  if (role === "Viewer" || role === "RM") {
    return navData.filter((item) => item.id !== 3);
  }

  if (role === "FM") {
    return navData.filter((item) => item.id === 1);
  }

  if (role === "TS") {
    return navData.filter(
      (item) => item.id !== 1 && item.id !== 3
    );
  }

  return navData;
};

export const getNavItemDefaultPath = (item) => {
  if (!item) {
    return null;
  }

  if (Array.isArray(item.children) && item.children.length > 0) {
    return normalizePath(item.children[0].link);
  }

  return normalizePath(item.link);
};

export const getFirstAccessibleRoute = (roleId) => {
  const accessibleNavItems = getAccessibleNavItems(roleId);

  if (accessibleNavItems.length === 0) {
    return null;
  }

  return getNavItemDefaultPath(accessibleNavItems[0]);
};

export const getAccessiblePaths = (roleId) => {
  const accessibleNavItems = getAccessibleNavItems(roleId);

  return accessibleNavItems.flatMap((item) => {
    if (Array.isArray(item.children) && item.children.length > 0) {
      return item.children.map((child) =>
        normalizePath(child.link)
      );
    }

    return [normalizePath(item.link)];
  });
};

export const doesRouteMatch = (currentPath, accessiblePath) => {
  const normalizedCurrentPath = normalizePath(currentPath);
  const normalizedAccessiblePath = normalizePath(accessiblePath);

  if (normalizedAccessiblePath === "/") {
    return normalizedCurrentPath === "/";
  }

  return (
    normalizedCurrentPath === normalizedAccessiblePath ||
    normalizedCurrentPath.startsWith(
      `${normalizedAccessiblePath}/`
    )
  );
};

export const canAccessRoute = (roleId, pathname) => {
  const accessiblePaths = getAccessiblePaths(roleId);

  return accessiblePaths.some((accessiblePath) =>
    doesRouteMatch(pathname, accessiblePath)
  );
};